var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgBrandLogowhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1600px",
    height: "307.7px",
    viewBox: "0 0 1600 307.7",
    style: {
      enableBackground: "new 0 0 1600 307.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#022269;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M434.8,145.9h-48.4l-9.2,22.3h-24.7L398.9,64h23.8l46.6,104.3H444L434.8,145.9z M427.2,127.6l-16.5-39.9 l-16.5,39.9H427.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M572.4,164.4c-4.8,3.4-11.8,5.1-18.9,5.1c-18.9,0-29.9-9.7-29.9-28.7v-32.9h-12.4V89.9h12.4V70.4h23.2v19.5 h20v17.9h-20v32.6c0,6.9,3.7,10.6,10,10.6c3.4,0,6.9-1,9.4-3L572.4,164.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M577,128.2c0-24.1,18.6-41.3,44.1-41.3c25.5,0,43.9,17.1,43.9,41.3s-18.5,41.3-43.9,41.3 C595.6,169.4,577,152.3,577,128.2z M641.5,128.2c0-13.9-8.8-22.2-20.4-22.2c-11.6,0-20.6,8.3-20.6,22.2 c0,13.9,8.9,22.2,20.6,22.2C632.7,150.4,641.5,142,641.5,128.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M820,139.8c0,18-14.3,28.5-41.7,28.5h-53.9V64h50.9c26.1,0,39.5,10.9,39.5,27.1c0,10.4-5.4,18.5-13.9,22.9 C812.5,117.7,820,126.7,820,139.8z M748.3,82.1v24.6h24c11.8,0,18.2-4.2,18.2-12.4c0-8.2-6.4-12.2-18.2-12.2H748.3z  M795.7,137.3c0-8.8-6.7-13-19.2-13h-28.2v25.8h28.2C789,150.1,795.7,146.2,795.7,137.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M904.5,83.3v27.6h48.3v19.4h-48.3v38h-24.1V64h78.8v19.4H904.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M974.7,122.4V64h24.1v57.5c0,19.8,8.6,28,23.2,28c14.7,0,23.2-8.2,23.2-28V64h23.8v58.4 c0,30.7-17.6,47.7-47.2,47.7C992.3,170,974.7,153,974.7,122.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1188.6,64v104.3h-19.8l-52-63.3v63.3H1093V64h20l51.8,63.3V64H1188.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1213.3,64h47.4c34.1,0,57.5,20.6,57.5,52.1s-23.4,52.1-57.5,52.1h-47.4V64z M1259.5,148.4 c20.7,0,34.3-12.4,34.3-32.3s-13.6-32.3-34.3-32.3h-22v64.6H1259.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1336.4,64h24.1v104.3h-24.1V64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1480.8,64v104.3H1461l-52-63.3v63.3h-23.8V64h20l51.8,63.3V64H1480.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1576,114.5h22v42.3c-11.5,8.6-27.3,13.3-42.2,13.3c-32.8,0-56.9-22.5-56.9-53.9s24.1-53.9,57.3-53.9 c18.3,0,33.5,6.3,43.6,18l-15.5,14.3c-7.6-8-16.4-11.8-27-11.8c-20.3,0-34.1,13.6-34.1,33.4c0,19.5,13.9,33.4,33.8,33.4 c6.6,0,12.7-1.2,18.8-4.5V114.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M367.9,207.6h-14.5v-3.8h33.4v3.8h-14.5v37.5h-4.4V207.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M443.9,245.2l-9.4-13.3c-1.1,0.1-2.1,0.2-3.3,0.2h-11.1v13.1h-4.4v-41.3h15.5c10.5,0,16.9,5.3,16.9,14.2 c0,6.5-3.4,11-9.4,13l10.1,14.2H443.9z M443.7,218c0-6.6-4.4-10.4-12.6-10.4h-11v20.7h11C439.3,228.4,443.7,224.5,443.7,218z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M506.3,234.1h-23l-5,11h-4.5l18.9-41.3h4.3l18.9,41.3h-4.6L506.3,234.1z M504.7,230.6l-9.9-22.2l-9.9,22.2 H504.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M579.3,203.9v41.3h-3.6l-26.5-33.5v33.5h-4.4v-41.3h3.6l26.6,33.5v-33.5H579.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M610.8,240.1l1.7-3.4c2.9,2.9,8.2,5,13.6,5c7.7,0,11.1-3.2,11.1-7.3c0-11.3-25.4-4.4-25.4-19.6 c0-6.1,4.7-11.3,15.2-11.3c4.7,0,9.5,1.4,12.8,3.7l-1.5,3.5c-3.5-2.3-7.7-3.4-11.3-3.4c-7.5,0-10.9,3.4-10.9,7.5 c0,11.3,25.4,4.5,25.4,19.5c0,6.1-4.8,11.3-15.4,11.3C620,245.5,613.9,243.3,610.8,240.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M699,234.1h-23l-5,11h-4.5l18.9-41.3h4.3l18.9,41.3h-4.6L699,234.1z M697.4,230.6l-9.9-22.2l-9.9,22.2H697.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M733.2,224.5c0-12.1,9.2-21,21.6-21c6,0,11.4,2,15.1,6l-2.8,2.8c-3.4-3.4-7.5-4.9-12.2-4.9 c-10,0-17.5,7.3-17.5,17.1c0,9.8,7.5,17.1,17.5,17.1c4.7,0,8.8-1.5,12.2-5l2.8,2.8c-3.7,4-9.1,6.1-15.2,6.1 C742.4,245.5,733.2,236.6,733.2,224.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M808.8,207.6h-14.5v-3.8h33.4v3.8h-14.5v37.5h-4.4V207.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M856.6,203.9h4.4v41.3h-4.4V203.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M892.8,224.5c0-12,9.2-21,21.7-21c12.4,0,21.6,8.9,21.6,21c0,12.1-9.3,21-21.6,21 C902,245.5,892.8,236.5,892.8,224.5z M931.8,224.5c0-9.8-7.4-17.1-17.3-17.1c-10,0-17.4,7.3-17.4,17.1c0,9.9,7.4,17.1,17.4,17.1 C924.5,241.6,931.8,234.4,931.8,224.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1002.5,203.9v41.3h-3.6l-26.5-33.5v33.5H968v-41.3h3.6l26.6,33.5v-33.5H1002.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1063.9,234.1h-23l-5,11h-4.5l18.9-41.3h4.3l18.9,41.3h-4.6L1063.9,234.1z M1062.3,230.6l-9.9-22.2 l-9.9,22.2H1062.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1102.4,203.9h4.4v37.5h23.1v3.8h-27.5V203.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1196.6,203.9h4.4v37.5h23.1v3.8h-27.5V203.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1282.6,241.4v3.8h-29.2v-41.3h28.3v3.8h-23.9v14.7h21.3v3.7h-21.3v15.3H1282.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1349.4,203.9v41.3h-3.6l-26.5-33.5v33.5h-4.4v-41.3h3.6l26.6,33.5v-33.5H1349.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1384.9,203.9h16.8c13.2,0,22.1,8.5,22.1,20.6c0,12.1-8.9,20.6-22.1,20.6h-16.8V203.9z M1401.5,241.4 c11,0,18-7,18-16.9c0-9.9-7.1-16.9-18-16.9h-12.2v33.7H1401.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1455.7,203.9h4.4v41.3h-4.4V203.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1530,203.9v41.3h-3.6l-26.5-33.5v33.5h-4.4v-41.3h3.6l26.6,33.5v-33.5H1530z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1594.6,224.5h4.2v15.7c-3.9,3.5-9.4,5.2-15.2,5.2c-12.6,0-21.8-8.9-21.8-21c0-12.1,9.2-21,21.8-21 c6.3,0,11.7,2,15.3,6l-2.7,2.8c-3.5-3.4-7.6-4.8-12.4-4.8c-10.2,0-17.7,7.3-17.7,17.1c0,9.8,7.5,17.1,17.6,17.1 c4,0,7.6-0.9,10.8-3.2V224.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M260.4,0H47.3C21.2,0,0,21.2,0,47.3v213.1c0,26.1,21.2,47.3,47.3,47.3h213.1c26.1,0,47.3-21.2,47.3-47.3V47.3 C307.7,21.2,286.5,0,260.4,0z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54,137c2.4,3.6,7.3,4.6,10.9,2.2l88.9-59.4l88.9,59.4c3.6,2.4,8.5,1.4,10.9-2.2v0c2.4-3.6,1.4-8.5-2.2-10.9 L168,70.2l-9-6c-3.2-2.1-7.3-2.1-10.5,0l-9,6L56.2,126C52.5,128.4,51.6,133.3,54,137L54,137z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M208.9,176c5.1-3.4,14.1-9.4,18.8-12.5c1.5-1,1.5-3.2,0-4.2c-4.7-3.1-13.6-9.1-18.8-12.5 c-1.7-1.1-3.9,0.1-3.9,2.1v4.6H86.8c-4.4,0-7.9,3.5-7.9,7.9v0c0,4.4,3.5,7.9,7.9,7.9H205v4.6C205,175.9,207.2,177.1,208.9,176z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.8,176.9l1.9,4.6c0.5,1.3,1.8,2.1,3.1,2.1H69c2.4,0,4.1-2.5,3.1-4.8l-10.5-23.4c-0.9-2-2.9-3.3-5.1-3.3 c-2.2,0-4.2,1.3-5.1,3.3l-10.4,23.4c-1,2.2,0.6,4.7,3.1,4.7c1.4,0,2.6-0.8,3.1-2.1l1.9-4.6H63.8z M56.5,159.4l5,12h-10 L56.5,159.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M261.2,167.3c2.6-1.3,4.2-3.8,4.2-6.9c0-4.9-4-8.2-11.9-8.2h-10.6c-2.6,0-4.7,2.1-4.7,4.7v21.9 c0,2.6,2.1,4.7,4.7,4.7h11.5c8.3,0,12.6-3.1,12.6-8.6C266.9,171.1,264.7,168.4,261.2,167.3z M245.3,157.7h7.2 c3.5,0,5.5,1.2,5.5,3.7c0,2.5-1.9,3.7-5.5,3.7h-7.2V157.7z M253.8,178.2h-8.5v-7.8h8.5c3.8,0,5.8,1.3,5.8,3.9 C259.6,177,257.6,178.2,253.8,178.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M252,193.7c-4.5-0.2-8.2,3.8-8.2,8.3v27.3H64.4v-27.7c0-2.2-0.9-4.2-2.3-5.6c-1.4-1.4-3.2-2.2-5.3-2.3 c-4.5-0.2-8.2,3.8-8.2,8.3v35.6c0,4.1,3.4,7.5,7.5,7.5h196c4.1,0,7.5-3.4,7.5-7.5v-35.9c0-2.2-0.9-4.2-2.3-5.6 C255.9,194.6,254,193.8,252,193.7z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgBrandLogowhite);
export default __webpack_public_path__ + "static/media/SVG_Brand Logo white.92369fab4d05d3f1974cedeaf151801a.svg";
export { ForwardRef as ReactComponent };